import * as React from 'react';
import { createSvgIcon } from '..';

export const Check = createSvgIcon(
  <><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 8l4.6667 7L15 1" /></>,
  'small',
);
